import { render, staticRenderFns } from "./universe.vue?vue&type=template&id=a68a0724&scoped=true&"
import script from "./universe.vue?vue&type=script&lang=js&"
export * from "./universe.vue?vue&type=script&lang=js&"
import style0 from "./universe.vue?vue&type=style&index=0&id=a68a0724&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68a0724",
  null
  
)

/* custom blocks */
import block0 from "@/lang/LandingTemplate.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Flayouts%2Funiverse.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OrganismsProjectOrganismLoader: require('/app/components/organisms/project/OrganismLoader.vue').default,MoleculesMoleculeMenuTriggerUniverse: require('/app/components/molecules/MoleculeMenuTriggerUniverse.vue').default,OrganismsUniverseOrganismTutorial: require('/app/components/organisms/universe/OrganismTutorial.vue').default,AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default,OrganismsOrganismMenuBarUniverse: require('/app/components/organisms/OrganismMenuBarUniverse.vue').default})
